const ApiConfig = {
    // baseUrl: "https://currencyexchangesoftware.eu/pilot/api",
    baseUrl: "https://www.pay-quik.co.uk/prod/api",
};
export default ApiConfig;
